<template>
  <div id="content">
    <h2>「お買物混雑マップ Powered by Beacon Bank」利用規約</h2>
    <p class="date">2020年5月1日制定</p>
    <p>株式会社unerry（以下「当社」）は、当社が提供するサービスである「お買物混雑マップ Powered by Beacon Bank」（以下「本サービス」といいます。）の利用について、以下の通り利用規約を定めます。（以下「本規約」といいます。）本サービスの利用者（以下「お客様」といいます。）は、予め本規約に同意した上で、本サービスを利用するものとします。 なお、本規約の内容は、第２条に従い変更することがございますので、本サービスをご利用の際には、最新の利用規約をご参照ください。</p>

    <h3>第１条（本サービスの目的）</h3>
    <p>本サービスは、日本全国のスーパーやドラッグストア等近辺の状況について、当社による推定混雑状況を公開することで、買い物に行くお店や時間を選ぶ際の参考として活用して頂くことを主な目的としています。また、本サービスにおいて公開しているデータは、当社が運営するBeacon Bankのデータを基に、統計的処理を行った上で、当社独自の推定情報として作成しております。</p>

    <h3>第２条（規約の変更）</h3>
    <p>1. 当社は、利用者の承諾を得ることなく、いつでも、本規約の内容を改定することができるものとし、利用者はこれを異議なく承諾するものとします。</p>
    <p>2. 利用者は、本規約変更後、本サービスを利用した時点で、変更後の本利用規約に異議なく同意したものとみなされます。</p>

    <h3>第３条（著作権等）</h3>
    <p>本サービスにかかる著作権およびデータにかかる権利（以下、「著作権等」といいます。）は、当社に所属します。この著作権等の対象には、サイトの構成、デザイン、イラスト・写真等のグラフィクス、文章など、全てを含みます。当社からの事前の同意を得ずに、転載・再配布することは、著作権等当社の権利の侵害となり、当社は当社に発生した損害の賠償を求める権利を有します。</p>

    <h3>第４条（禁止行為）</h3>
    <p>本サービスの利用に際し、当社は、利用者に対し、次に掲げる行為を禁止します。</p>
    <p>（１）当社または第三者の知的財産権を侵害する行為</p>
    <p>（２）当社または第三者の名誉・信用を毀損または不当に差別もしくは誹謗中傷する行為</p>
    <p>（３）当社または第三者の財産を侵害する行為、または侵害する恐れのある行為</p>
    <p>（４）当社または第三者に経済的損害を与える行為</p>
    <p>（５）当社または第三者に対する脅迫的な行為</p>
    <p>（６）コンピューターウィルス、有害なプログラムを仕様またはそれを誘発する行為</p>
    <p>（７）本サービス用インフラ設備に対して過度な負担となるストレスをかける行為</p>
    <p>（８）当サイトのサーバーやシステム、セキュリティへの攻撃</p>
    <p>（９）当社提供のインターフェース以外の方法で当社サービスにアクセスを試みる行為</p>
    <p>（１０）上記の他、当社が不適切と判断する行為</p>

    <h3>第５条（免責）</h3>
    <p>当社は、本サービスの運営に万全を期すよう努めますが、本サービスは、実際の来店者数・混雑状況を計測したものではなく、店舗等近辺についての混雑状況の推定情報の提供であり、また、本サービスの内容、情報等について、その完全性、正確性等についてはいかなる保証も行わず、これらに起因して生じた損害に関しても一切責任を負わないものとします。また、以下の各号につきあらかじめご了承いただくものとします。</p>
    <p>（１）当社は、掲載された施設の所在地にかかる地図情報に関してはいかなる保証もいたしません。各施設の最新の状況につきましては、別途ご確認ください。</p>
    <p>（２）当社は、掲載された推定混雑情報の内容に関してはいかなる保証もいたしません。本サービスの情報は、判断材料の1つとしてご利用ください。</p>
    <p>（３）本サービスの利用者が、本サービスの内容、情報等の利用によって第三者に対して損害を与えた場合、利用者は自己の責任と費用負担によってその損害・損失を処理・解決するものとし、当社はかかる損害・損失に対していかなる責任も負いません。</p>
    
    <h3>第６条（当社への連絡方法）</h3>
    <p>本サービスに関する利用者の当社へのご連絡・お問い合わせは、本サービスまたは当社が運営するwebサイト内の適宜の場所に設置するお問い合わせフォームからの送信または当社が別途指定する方法により行うものとします。</p>
    
    <h3>第７条（本サービスの変更・中断等）</h3>
    <p>1. 当社は、以下のいずれかの事由が生じた場合には、利用者に事前に通知することなく、一時的に本サービスの全部または一部の提供を変更・中断することがあります。 </p>
    <p>（１）本サービスを提供するための通信設備等の定期的な保守点検を行う場合または点検を緊急に行う場合</p>
    <p>（２）火災、停電等により本サービスの提供ができなくなった場合 </p>
    <p>（３）地震、噴火、洪水、津波等の天災により本サービスの提供ができなくなった場合 </p>
    <p>（４）戦争、動乱、暴動、騒乱、労働争議等により本サービスの提供ができなくなった場合</p>
    <p>（５）その他、運用上または技術上、当社が本サービスの提供の一時的な中断を必要と判断した場合</p>
    <p>2. 当社は、当社が必要と判断した場合には、事前に通知することなくいつでも本サービスの内容を変更し、または本サービスの提供を停止もしくは中止することができるものとします。</p>
    <p>3. 当社は、第1項各号のいずれかまたはその他の事由により本サービスの全部または一部の提供に遅延もしくは中断が発生しても、これに起因する利用者または第三者が被った損害に関し、一切の責任を負いません。</p>
    <p>4. 当社は、当社が本サービスの内容を変更し、または本サービスの提供を停止もしくは中止した場合であっても、利用者に対して一切責任を負わないものとします。</p>
    
    <h3>第８条（準拠法、管轄裁判所）</h3>
    <p>1. 本規約の有効性，解釈及び履行については，日本法に準拠し，日本法に従って解釈されるものとする。</p>
    <p>2. 当社と利用者等との間での論議・訴訟その他一切の紛争については、訴額に応じて、東京簡易裁判所又は東京地方裁判所を専属的合意管轄裁判所とします｡</p>
    
    <p class="note">※（WEB解析ツールについて）</p>
    <p>本サイトの一部では、お客様により使いやすく、有用な情報サービスを提供させて頂くため、WEB解析ツール（Googleアナリティクス）を使用しています。本WEB解析ツールのプライバシーポリシーについては、以下ホームページをご覧ください。</p>
    <p v-if="!isWV"><a href="https://policies.google.com/" target="_blank">https://policies.google.com/</a></p>
    <p v-else>https://policies.google.com/</p>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex'

export default defineComponent({
  name: 'Content',
  computed: {
    ...mapGetters(['isWV']),
  },
})
</script>

<style scoped lang="scss">
h2 {
  margin-top: 0;
  text-align: center;
  font-size: 18px;
}
.date {
  margin-top: 38px;
  margin-bottom: 22px;
  text-align: right;
  font-size: 12px;
}
h3 {
  margin-top: 12px;
  margin-bottom: 0;
  text-align: left;
  font-size: 12px;
  font-weight: bold;
  line-height: 20px;
}
p {
  margin: 0;
  font-size: 12px;
  line-height: 20px;
  color: #000;
}
.note {
  margin-top: 12px;

  & + p {
    text-indent: 1.0em;
  }
}
a {
  color: #000;
}

@media screen and (max-width: 767px) {
  h3 {
    margin-top: 13px;
    font-size: 11px;
    line-height: 18px;
  }
  p {
    font-size: 11px;
    line-height: 18px;
  }
}
</style>
